(function () {
  'use strict';

  angular
    .module('erpRetail', [
      'ngAnimate',
      'ngCookies',
      'ngLocale',
      'ngMessages',
      'ngResource',
      'ngSanitize',
      'ngStorage',
      'ngTouch',
      'angular-table',
      'angular.filter',
      'angularFileUpload',
      'angularUtils.directives.dirPagination',
      'angularValidator',
      'as.sortable',
      'bootstrapLightbox',
      'CookieComponent',
      'gridster',
      'jlareau.pnotify',
      'oc.lazyLoad',
      'pascalprecht.translate',
      'truncate',
      'ui.ace',
      'ui.bootstrap',
      'ui.cgdevtools',
      'ui.CGImageCache',
      'ui.router',
      'ui.sortable',
      'ui.tinymce',
      'ui.tree',
      'xeditable',
      'cgReservasEstadias',
      'pl.comps'
    ])
    .config(function ($logProvider, $stateProvider, $urlRouterProvider, $locationProvider, $httpProvider, $translateProvider, plFormatProvider, ENV, KEYCODE, $qProvider) {
      if (ENV !== 'dev') {
        $stateProvider.stateService.defaultErrorHandler(function () {
          // Do not log transitionTo errors
        });
      }

      $qProvider.errorOnUnhandledRejections(false);

      $translateProvider.useStaticFilesLoader({
        prefix: 'i18n/locale-',
        suffix: '.json'
      });
      $translateProvider.preferredLanguage('pt-pt');
      $translateProvider.useCookieStorage();
      $translateProvider.useSanitizeValueStrategy('escaped');

      moment.locale('pt-pt');

      plFormatProvider.setFormat({
        decimalsSeparator: ',',
        decimalsSeparatorCode: KEYCODE.COMMA,
        decimalsLimit: 2,
        thousandsSeparator: '.'
      });

      $stateProvider
        .state('home', {
          url: '/',
          title: 'Home',
          abstract: true,
          templateUrl: 'app/index.html',
          controller: function (configSite) {
          },
          controllerAs: 'ctrl',
          resolve: {
            configSite: ['configFactory', function (configFactory) {
              return configFactory.getConfigSite();
            }]
          }
        });
    })
    .run(function ($rootScope, $window, $transitions, $state, $stateParams, $translate, Auth, editableOptions, CONFIG, configFactory, ENV, ImagensFactory,
                   $rootElement, $sce, $location, plTranslate, localStorageService) {
      $rootScope.ENV = ENV;
      $rootScope.getDatetime = new Date();
      $rootScope.$state = $state;
      $rootScope.$stateParams = $stateParams;
      $rootScope.$config = {loaded: false, getTemplate: configFactory.getTemplate, metaTitle: null};
      $rootScope.app = {};
      $rootScope.getImagem = ImagensFactory.getImagem;

      $rootScope.init = init;
      $rootScope.getLogo = getLogo;
      $rootScope.getLogoLogin = getLogoLogin;
      $rootScope.getFavicon = getFavicon;
      $rootScope.setCss = setCss;
      $rootScope.globalGoTo = globalGoTo;
      $rootScope.globalTranslate = globalTranslate;
      $rootScope.goBack = goBack;
      $rootScope.home = home;

      $rootScope.init();

      /////////////

      function init() {
        plTranslate.setTranslateFn($rootScope.globalTranslate);
        editableOptions.theme = 'bs3';

        configFactory.getConfigSite().then(function (data) {
          $rootScope.setCss(data.modelos.maincss);
        });

        $transitions.onStart({}, function ($transition) {
          var toState = $transition.$to();
          var params = $transition.params();
          $rootScope.app.state = toState.self;
          $rootScope.app.stateParams = params;

          configFactory.getConfigSite().then(
            function (response) {
              if (response.siteFixedTitle) {
                $rootScope.$config.data.metaTitle = plTranslate.translate(response.siteFixedTitle);
              }
              else if (toState.self.title) {
                // Set meta title
                var pageTitle = toState.self.title.toString().trim() !== '' ? ' - ' + plTranslate.translate(toState.self.title) : '';
                $rootScope.$config.data.metaTitle = $rootScope.$config.data.siteName + pageTitle;
              }

              // Trying to access sign up but it is disabled
              if (toState.self.name === 'signup' && parseInt(response.siteSignupEnabled) === 0) {
                $transition.router.stateService.go('login', {ReturnState: toState.self.name, Params: angular.toJson(params)});
              }

              // Trying to access sign up but it is disabled
              if (toState.self.name !== 'user.recover_email' && toState.self.name !== 'user.confirm_token' &&
                toState.self.name !== 'user.nova' && toState.self.name !== 'signup' && response.siteLojaRegisteredOnly && !Auth.isLoggedIn()) {
                $transition.router.stateService.go('login');
              }
            }
          );

          var fromState = $transition.$from();
          if (fromState.name === '') {
            var refreshed = localStorageService.get('refreshed') || false;
            $rootScope.app.refreshed = refreshed === true || refreshed === 'true';
            localStorageService.set('refreshed', false);
          }

          // Preserving query params
          var queryParams = $location.search();
          if (queryParams) {
            // Checking if we're in a detail page; if so, we don't save it's params
            for (var param in queryParams) {
              if (queryParams.hasOwnProperty(param) && param.indexOf('type') !== -1 && queryParams[param].toString().indexOf('detail') !== -1) {
                return;
              }
            }
            $rootScope.app.queryParams = queryParams;
          }

          $rootScope.app.params = params;

          if (!params) {
            return;
          }
          Auth.isLoggedInAsync(function (loggedIn) {
            if ((params.authenticate === true || params.authenticate === 'admin') && loggedIn === false) {
              $transition.router.stateService.go('login', {ReturnState: toState.self.name, Params: angular.toJson(params)});
            }
          });
        });

        // New implementation of the old $stateChangeStart
        $transitions.onSuccess({}, function ($transition) {
          var fromState = $transition.$from();
          var fromParams = $transition.params('from');
          $rootScope.app.previousState = fromState.name;
          $rootScope.app.previousStateParams = _.merge({}, $rootScope.app.queryParams, fromParams);
        });
      }

      function getLogo() {
        if ($rootScope.$config.loaded) {
          return ImagensFactory.getImagem($rootScope.$config.data.siteLogo, 'assets/images/online-store-logo.png');
        }
      }

      function getLogoLogin() {
        if ($rootScope.$config.loaded) {
          return ImagensFactory.getImagem($rootScope.$config.data.loginLogo, 'assets/images/online-store-logo.png');
        }
      }

      function getFavicon() {
        if ($rootScope.$config.loaded) {
          return $sce.trustAsResourceUrl(ImagensFactory.getImagem($rootScope.$config.data.sitefavicon, 'assets/images/favicon.ico'));
        }
      }

      function setCss(css) {
        if (angular.isUndefined($rootScope.css)) {
          $rootScope.css = angular.element('<style>');
          $rootElement.append($rootScope.css);
        }
        $rootScope.css.text('\n' + css + '\n');
      }

      function globalGoTo(name, params, options) {
        $state.go(name, params, options);
      }

      function globalTranslate(key, params, config) {
        return $translate.instant(key, params, config);
      }

      function goBack() {
        if ($rootScope.app.previousState === '' || $window.history.length === 0) {
          return $rootScope.home();
        }
        else if (!$rootScope.app.previousState || !$state.get($rootScope.app.previousState) || $rootScope.app.previousState === 'disconnected') {
          return $window.history.back();
        }
        else {
          return $state.go($rootScope.app.previousState, $rootScope.app.previousStateParams).then(null, function () {
            $rootScope.home();
          });
        }
      }

      function home() {
        return $state.go('loja.home', {id: 'inicio'});
      }
    });
})();
